import { GIFT_CARD } from '~/const/gift-card';
import { CATEGORY_INFIX, EDITO_INFIX, PRODUCT_INFIX, STATIC_INFIX, SEARCH_INFIX } from '~/const/infix';
import USE_MERCURE from '~/const/mercure';
var buildHomeUrl = function buildHomeUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language);
};
var CgvType = {
  default: 'cgv',
  pro: 'cgv-pro'
};
var CguType = {
  FR: {
    default: 'cgu-acheteurs-marketplace',
    pro: 'cgu-acheteurs-marketplace-business'
  },
  ES: {
    default: 'cgu-compradores-marketplace',
    pro: 'cgu-compradores-marketplace-business'
  },
  IT: {
    default: 'cgu-marketplace ',
    pro: 'cgu-marketplace-business '
  },
  DE: {
    default: 'agb-verkäufer-marketplace',
    pro: 'agb-marketplace-business'
  }
};
var buildCategoryUrl = function buildCategoryUrl(locale, slug, hash) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(CATEGORY_INFIX, "/").concat(slug, "-").concat(hash);
};
var buildProductUrl = function buildProductUrl(locale, slug, reference, offer) {
  var url = "/".concat(locale.market, "/").concat(locale.language, "/").concat(PRODUCT_INFIX, "/").concat(slug, "-").concat(reference, ".htm");
  if (offer) {
    url = "".concat(url, "?offer=").concat(offer);
  }
  return url;
};
var buildGiftCardUrl = function buildGiftCardUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/gc/").concat(GIFT_CARD[locale.iso].eGift);
};
var buildCustomProductUrl = function buildCustomProductUrl(locale, reference) {
  return "/".concat(locale.market, "/").concat(locale.language, "/configurator/product/").concat(reference);
};
var buildStaticUrl = function buildStaticUrl(locale, slug, oldVersion) {
  if (oldVersion) {
    // handle WEB static pages url until they switch to nuxt
    return "/".concat(locale.market, "/").concat(locale.language, "/").concat(slug);
  }
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(STATIC_INFIX, "/").concat(slug);
};
var buildSearchUrl = function buildSearchUrl(locale, query) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(SEARCH_INFIX, "/").concat(query);
};
var buildEditoUrl = function buildEditoUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/").concat(page);
};
var buildMyAccountUrl = function buildMyAccountUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/user");
};
var buildFaqUrl = function buildFaqUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/help/faq/").concat(page);
};
var buildContactFormUrl = function buildContactFormUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/help/contact/").concat(page);
};
var buildReturnFormUrl = function buildReturnFormUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/help/return/").concat(page);
};
var buildCgvUrl = function buildCgvUrl(locale, isPro) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/legal/").concat(CgvType[isPro ? 'pro' : 'default']);
};
var buildCguUrl = function buildCguUrl(locale, isPro) {
  if (!CguType[locale.market]) return null; // if url market undefined, return blank url

  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/legal/").concat(CguType[locale.market][isPro ? 'pro' : 'default']);
};
var buildShippingUrl = function buildShippingUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/shipping");
};
var buildPaymentUrl = function buildPaymentUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/payment");
};
var buildMkpConfirmationUrl = function buildMkpConfirmationUrl(locale) {
  console.log("/".concat(locale.market, "/").concat(locale.language, "/t/confirmation"));
  return "/".concat(locale.market, "/").concat(locale.language, "/t/confirmation");
};
var buildPaymentPaypalPendingUrl = function buildPaymentPaypalPendingUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/payment-paypal-pending");
};
var buildPaymentPaypalCanceledUrl = function buildPaymentPaypalCanceledUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/payment-paypal-canceled");
};
var buildPaymentConfirmedUrl = function buildPaymentConfirmedUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/confirmed");
};
var buildPaymentRefusedUrl = function buildPaymentRefusedUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/refused");
};
var buildMerchantUrl = function buildMerchantUrl(locale, reference) {
  return "/".concat(locale.market, "/").concat(locale.language, "/m/").concat(reference);
};
var buildCartUrl = function buildCartUrl(locale) {
  return USE_MERCURE(locale.iso) ? "/".concat(locale.market, "/").concat(locale.language, "/cart") : "/".concat(locale.market, "/").concat(locale.language, "/panier.html");
};
var buildLoginUrl = function buildLoginUrl(locale, isTunnel) {
  return isTunnel ? "/".concat(locale.market, "/").concat(locale.language, "/t/login") : "/".concat(locale.market, "/").concat(locale.language, "/login");
};
var buildSignupUrl = function buildSignupUrl(locale, isTunnel) {
  return isTunnel ? "/".concat(locale.market, "/").concat(locale.language, "/t/signup") : "/".concat(locale.market, "/").concat(locale.language, "/signup");
};
var buildGiftCardDownloadUrl = function buildGiftCardDownloadUrl(locale, hashPdf) {
  return "/".concat(locale.market, "/").concat(locale.language, "/user/gift-card-download?hashPdf=").concat(hashPdf);
};
var buildSignupPaypalExpressUrl = function buildSignupPaypalExpressUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/t/signup-paypal-express");
};
var buildSignupPaypalExpressPendingUrl = function buildSignupPaypalExpressPendingUrl(locale) {
  return "".concat(locale.market, "/").concat(locale.language, "/t/signup-paypal-express-pending");
};
var buildSignupPaypalExpressCanceledUrl = function buildSignupPaypalExpressCanceledUrl(locale) {
  return "".concat(locale.market, "/").concat(locale.language, "/t/signup-paypal-express-canceled");
};
export var urlBuilder = {
  buildCartUrl: buildCartUrl,
  buildCgvUrl: buildCgvUrl,
  buildCguUrl: buildCguUrl,
  buildShippingUrl: buildShippingUrl,
  buildHomeUrl: buildHomeUrl,
  buildLoginUrl: buildLoginUrl,
  buildMerchantUrl: buildMerchantUrl,
  buildMyAccountUrl: buildMyAccountUrl,
  buildPaymentUrl: buildPaymentUrl,
  buildMkpConfirmationUrl: buildMkpConfirmationUrl,
  buildPaymentPaypalPendingUrl: buildPaymentPaypalPendingUrl,
  buildPaymentPaypalCanceledUrl: buildPaymentPaypalCanceledUrl,
  buildPaymentConfirmedUrl: buildPaymentConfirmedUrl,
  buildPaymentRefusedUrl: buildPaymentRefusedUrl,
  buildProductUrl: buildProductUrl,
  buildGiftCardUrl: buildGiftCardUrl,
  buildCustomProductUrl: buildCustomProductUrl,
  buildSignupUrl: buildSignupUrl,
  buildSignupPaypalExpressUrl: buildSignupPaypalExpressUrl,
  buildSignupPaypalExpressPendingUrl: buildSignupPaypalExpressPendingUrl,
  buildSignupPaypalExpressCanceledUrl: buildSignupPaypalExpressCanceledUrl
};
export default {
  methods: {
    buildHomeUrl: buildHomeUrl,
    buildCartUrl: buildCartUrl,
    buildCategoryUrl: buildCategoryUrl,
    buildCustomProductUrl: buildCustomProductUrl,
    buildContactFormUrl: buildContactFormUrl,
    buildEditoUrl: buildEditoUrl,
    buildFaqUrl: buildFaqUrl,
    buildGiftCardDownloadUrl: buildGiftCardDownloadUrl,
    buildLoginUrl: buildLoginUrl,
    buildMerchantUrl: buildMerchantUrl,
    buildProductUrl: buildProductUrl,
    buildGiftCardUrl: buildGiftCardUrl,
    buildReturnFormUrl: buildReturnFormUrl,
    buildSearchUrl: buildSearchUrl,
    buildStaticUrl: buildStaticUrl
  }
};